import { render } from "./FacilityAdminMenu.vue?vue&type=template&id=4916bee5&scoped=true"
import script from "./FacilityAdminMenu.vue?vue&type=script&lang=js"
export * from "./FacilityAdminMenu.vue?vue&type=script&lang=js"

import "./FacilityAdminMenu.vue?vue&type=style&index=0&id=4916bee5&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4916bee5"]])

export default __exports__